import type { AxiosResponse } from "axios";

import { downloadFile } from "../../utils";
import api from "../../../../../api";
import type { CommandFormValues } from "../../types";
import { exportEURTransactionsRequestSchema } from "./types";
import type { IUser } from "../../../../../types";
import {
  buildExportFileName,
  getFileNameFromContentDisposition,
} from "../../../../../utils";
import { validateValues } from "../../utils";

export const handleEURTransactions = async (
  user: IUser,
  values: CommandFormValues
): Promise<AxiosResponse> => {
  const { date, fileType, elsterField } = validateValues(
    values,
    exportEURTransactionsRequestSchema
  );

  const response = await api.kontax.exportEURTransactions(
    user.id,
    date,
    fileType,
    elsterField
  );

  const contentTypeHeader = response.headers["content-type"];
  const contentType =
    typeof contentTypeHeader === "string" ? contentTypeHeader : undefined;

  const contentDispositionHeader = response.headers["content-disposition"];
  const contentDisposition =
    typeof contentDispositionHeader === "string"
      ? contentDispositionHeader
      : undefined;

  const blob = new Blob([response.data], {
    type: contentType,
  });

  const downloadUrl = window.URL.createObjectURL(blob);
  const fileName =
    getFileNameFromContentDisposition(contentDisposition) ||
    buildExportFileName({
      user,
      exportType: `EUeR ${elsterField}`,
      period: { kind: "year", year: date.year() },
      extension: fileType,
    });

  downloadFile(downloadUrl, fileName);
  // Revoke the object URL to avoid memory leaks.
  window.URL.revokeObjectURL(downloadUrl);

  return response;
};
